export const MIN_ASSETS_NUMBER_FOR_BENTLEY_MODEL = 10
export const FEET_IN_METER = 3.28084
